import { render } from "./myleads_list.vue?vue&type=template&id=71c61eca&scoped=true"
import script from "./myleads_list.vue?vue&type=script&lang=js"
export * from "./myleads_list.vue?vue&type=script&lang=js"

import "./myleads_list.vue?vue&type=style&index=0&id=71c61eca&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c61eca"]])

export default __exports__